import React, { Component, } from 'react';
import { lang } from'../Helpers/lang';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import Select from 'react-select';
import $ from 'jquery';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl} from'../Config/Config';
import { computeFilterFromHex } from '../Helpers/cssFilterSolver';
import axios from 'axios';
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const navigate = useNavigate();
	// etc... other react-router-dom v6 hooks

	return (
		<WrappedComponent
			{...props}
			params={params}
			navigate={navigate}
		// etc...
		/>
	);
};
class Edit extends Component {
	
	constructor(props)
	{
		super(props);
		const id = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		//const id = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;

		this.state = {
		  list_id : id,
	      login_type:'',
	      show_count_yes:true,
	      show_count_no:false,
	      name:'',
	      module_type:'',
	      module_type_value:'',
	      priorty:'',
		  content:'',
		  image_preview:'',
		  image_name:'',
		  image:'',
	      name_arr:[],
	      module_type_arr:[],
	      module_type_value_arr:[],
	      priorty_arr:[],
		  content_arr:'',
		  image_preview_arr:'',
		  image_name_arr:'',
	      showlayout: false,
	      select_options:'',
	      select_options_arr:[],
	      selectedvalue: '',
          selectedOption:{ value: 'active', label: 'Active'},
          Loading:false,
		  show_count_arr:[],
		  image_arr:[],
          editindex:'',
          field_ids:[],
		  remove_ids:'',
		  removeall_ids:'',
		  login_type:'',
		  image_name_single:'',
		  bg_image_name_arr:'',
		  bg_image_name:'',
		  bg_image_preview: '',
		  bg_image: '',
		  db_bg_image_name:'',
		  show_count: 'yes',
		   show_tooltip: 'yes',
		  	text_color: '#111111',
			text_color_arr: [],
		  	count_color: '#111111',
			count_color_arr: [],
			text_size: '',
			text_size_arr: [],
			count_size: '',
			count_size_arr: [],
			bg_image_arr:[],
			dashboard_block:'',
			dashboard_block_sel:'',
			dashboard_block_arr:[],
            show_tooltip_arr:[],
			icon_width_arr:[],
			mini_dropdown_list:false,
			blockCounts:{},
			new_image_counter:0,
			new_bgimage_counter:0,
			block_image_counter:0,
			filtered_page_options:[],
			db_image_name: '',
			db_bg_image_name:'',
			dashboarddata:[],
			dashboard_blocks: [],
			icon_color_filter: '',
			icon_color_loss: '',
			deleteId:'',
			status:''
		};
 }
	

    getDashboardDetail =() =>{
	   var qs = require('qs');
		var listid = this.state.list_id || this.props.params.id;

		if(!listid) return;

		axios.get(apiUrl+"dashboardmanagment/listdetail?id="+listid).then(res => {
			if(res.data.status == "success" ){
				var dashdata =res.data
				var filteredlinks = dashdata.dashboard_pages;

				//var filteredlinks =lang.common.dashboard_page_options.filter(item=>(item.type==dashdata.usertype));
				const formdata = res.data.data;
				const block1count = dashdata.dashboarddata.filter(item => item.dashboard_block === "block1").length;
				const block2count = dashdata.dashboarddata.filter(item => item.dashboard_block === "block2").length;
				const block3count = dashdata.dashboarddata.filter(item => item.dashboard_block === "block3").length;
				const block4count = dashdata.dashboarddata.filter(item => item.dashboard_block === "block4").length;
				
				this.setState({
					blockCounts:{
						block1:block1count,
						block2:block2count,
						block3:block3count,
						block4:block4count
					}
	
				})
				this.setState({
					login_type : {value:dashdata.usertype, label:dashdata.usertype},
					showlayout: true, 
					login_type_value: dashdata.usertype,
					dashboarddata:dashdata.dashboarddata,
					filtered_page_options:filteredlinks})
				if (dashdata.dashboard_blocks && dashdata.dashboard_blocks.length>0) {
				const blocksWithIds = dashdata.dashboard_blocks.map(block => ({
					...block,
					dashboard_id: this.state.list_id,
					db_bl_image_name: block.image || '',
					action: 'no'
				}));
				this.setState({ dashboard_blocks: blocksWithIds });
				}
				else{
					const dashblocks= lang.common.dashboard_blocks.map((item)=>{
					 return{"title":item.value,"label":item.label}
					})
					this.setState({ dashboard_blocks: dashblocks });
				}
			}
			}); 
						  
	 }
	componentDidMount() {
		if(localStorage.getItem("admin_id") === 'undefined' && localStorage.getItem('admin_id') === '' && localStorage.getItem('admin_id') === null){
			this.props.history.push('/');
 	    }
		this.loadDashboardData();
    }

	componentDidUpdate(prevProps) {
		const currentId = this.props.params.ID;
		const prevId = prevProps.params.ID;
		if(currentId !== prevId) {
			this.setState({ list_id: currentId }, () => this.loadDashboardData());
		}
	}

	loadDashboardData = () => {
		const id = this.props.params.ID;
		if(id) {
			this.setState({ list_id: id }, () => this.getDashboardDetail());
		}
	}

  
	handleInputChange = (event) =>{
    const { name, type, value, checked  } = event.target;

	const finalValue = type === "checkbox" ? checked : value;

    this.setState({ [name]: finalValue });
    if(name == "icon_color"){
		const hex = event.target.value;
		this.setState({ icon_color: hex });
		
		const { filter, loss } = computeFilterFromHex(hex);
		this.setState({ icon_color_filter: filter, icon_color_loss: loss });
	}
    if(name === 'form_column'){
       this.setState({form_one_column: !this.state.form_one_column});
       this.setState({form_two_column: !this.state.form_two_column});
    }
    if(name === 'field_required'){
        this.setState({field_required_checked: !this.state.field_required_checked});
    }
    if(name == 'select_options'){
        this.setState({select_options:value})
    }
	if (name === 'show_count') {
		this.setState({ show_count: value });
	}
	
	if (name === "mini_dropdown_list") {
    this.setState({ mini_dropdown_list: checked });
  }
  }

  handleChange = login_type => {
	this.setState({login_type})
	this.setState({  login_type_value : login_type.value});
};

onChangeHandler = event => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const Index = this.state.editindex;

	// Use existing image name if editing, otherwise create new name with incremented counter
	const imageName = (Index !== '' && this.state.dashboarddata[Index]?.image_name)
		? this.state.dashboarddata[Index].image_name
		: `image_${this.state.new_image_counter}`;

	reader.onloadend = () => {
		this.setState({
			image_name: imageName,
			image_preview: reader.result,
			image: file,
			db_image_name: '',
			new_image_counter: this.state.new_image_counter + 1
		});
	};
	reader.readAsDataURL(file);
}

removeImagePreview = () => {
	this.setState({
		db_image_name: "",
		image_preview: "" 
	});
};

removeBgImagePreview = () =>{
	this.setState({
		db_bg_image_name: "",
		bg_image_preview: "" 
	});
}

onChangeBgImgHandler = event => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const Index = this.state.editindex;

	// Use existing bg image name if editing, otherwise create new name with incremented counter
	const bgImageName = (Index !== '' && this.state.dashboarddata[Index]?.bg_image_name)
		? this.state.dashboarddata[Index].bg_image_name
		: `bgimage_${this.state.new_bgimage_counter}`;

	reader.onloadend = () => {
		this.setState({
			bg_image_name: bgImageName,
			bg_image_preview: reader.result,
			bg_image: file,
			db_bg_image_name: '',
			new_bgimage_counter: this.state.new_bgimage_counter + 1
		});
	};
	reader.readAsDataURL(file);
}

onChangeBlockBgImgHandler = (index) => (event) => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const block = this.state.dashboard_blocks[index];
	const title = lang.common.dashboard_blocks[index]?.value;
	// Use existing image name if block has one, otherwise create new name with incremented counter
	const blockImageName = (block?.image_name && block.image_name !== '')
		? block.image_name
		: `block_image_${this.state.block_image_counter}`;

	reader.onloadend = () => {
		const blocks = [...this.state.dashboard_blocks];
		blocks[index] = {
			...blocks[index],
			title: title,
			image: file,
			image_name: blockImageName,
			preview: reader.result,
			action: blocks[index]?.id ? 'edit' : 'add'
		};
		this.setState({
			dashboard_blocks: blocks,
			block_image_counter: this.state.block_image_counter + 1
		});
	};
	reader.readAsDataURL(file);
}

removeBlockBgImagePreview = (index) => {
	const blocks = [...this.state.dashboard_blocks];
	blocks[index] = {
		...blocks[index],
		image: '',
		preview: '',
		db_bl_image_name:'',
		image:'',
		image_name: '',
		action: blocks[index].id ? 'edit' : 'add'
	};
	this.setState({ dashboard_blocks: blocks });
}

 
  handleFormSubmit = () => {
	
		this.setState({Loading:true});
			const config = {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
			};
 
		const formPayload = this.state;
		var qs = require('qs');
		 var updatedashboarddata= formPayload.dashboarddata.filter(item => item.action === 'edit' || item.action === 'add').map(item => ({
				id: item.column_id || '',
				name: item.name || '',
				module_type_value: item.module_type_value || '',
				priorty: item.priorty || '',
				text_size: item.text_size || '',
				text_color: item.text_color || '',
				count_color: item.count_color || '',
				count_size: item.count_size || '',
				show_count: item.show_count || '',
				show_tooltip: item.show_tooltip,
				dashboard_block: item.dashboard_block,
				show_tooltip: item.show_tooltip,
				icon_width: item.icon_width,
				icon_color:item.icon_color,
				svg_icon_color:item.icon_color_filter,
				content: item.content || '',
				image_name: item.image_name || '',
				bg_image_name:item.bg_image_name ||'',
				icon_image_name: item.icon_image_name || '',
				db_image_name: item.db_image_name || '',
				db_bg_image_name:item.db_bg_image_name ||'',
				db_icon_image_name: item.db_icon_image_name || '',
				status:item.status|| '',
				// enable_list: item.enable_list || '',
				// dashboard_img_type: item.dashboard_img_type || '',
				// dashb_img_max_height: item.dashb_img_max_height || '',
				// dashb_img_max_width: item.dashb_img_max_width || '',
				// dashb_img_position: item.dashb_img_position || '',
				action: item.action || ''
			}))
		var updatedblockdata = formPayload.dashboard_blocks.map(block => ({
				id: block.id || '',
				dashboard_id: this.state.list_id,
				title: block.title || '',
				color: block.color || '',
				db_bl_image_name: block.db_bl_image_name || '',
				image_name: block.image_name || '',
				action: block.action
			}))
		 console.log("updatedashboarddata", updatedashboarddata);
		 console.log("updatedblockdata", updatedblockdata);
		var postObject = {
			admin_id : localStorage.getItem("admin_id"),
			user: formPayload.login_type_value,
			list_id : this.state.list_id,
			//edit_id:this.state.dashboarddata[this.state.editindex].column_id,
			removeid: formPayload.remove_ids,
			removeallid: formPayload.removeall_ids,
			dashboard_data: JSON.stringify(updatedashboarddata),
			dashboard_blocks: JSON.stringify(updatedblockdata),
			
		};
		//this.props.getEditForm(qs.stringify(postObject));
		//return false;
		let formData = new FormData();
 
		for(let k in postObject) {
			formData.append(k, postObject[k]);
		}
		// Append images from dashboarddata array using image_name
		formPayload.dashboarddata.forEach((item) => {
			if(item.new_image && item.image_name) {
				formData.append(`update_image[${item.image_name}]`, item.new_image);
			}
			if(item.new_bg_image && item.bg_image_name) {
				formData.append(`update_bgimage[${item.bg_image_name}]`, item.new_bg_image);
			}
		});
 
		// Append icon images using icon_name
		formPayload.dashboarddata.forEach((item) => {
			if(item.icon_image && item.icon_image_name) {
				formData.append(`update_icon[${item.icon_image_name}]`, item.icon_image);
			}
		});
 
		// if (this.state.bg_image) {
		// 	formData.append("update_bgimage", this.state.bg_image);
		// }
 
			formPayload.dashboard_blocks.forEach((block) => {
				if (block.image && typeof block.image === 'object' && block.image_name) {
					formData.append(`dashboard_block_image[${block.image_name}]`, block.image);
				}
			});
 
		axios.post(apiUrl+"dashboardmanagment/edit",formData,config).then(res => {
			if(res.data.status === "success"){
				this.setState({Loading:false});
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				scrollToTop();
				setTimeout(function() {
					$('.success_message').html('');
					this.getDashboardDetail();
				}.bind(this), 3000);
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				scrollToTop();
				setTimeout(function() {
					$('.success_message').html('');
				}.bind(this), 3000);
			}
		});
	}


  Addtolayout = () => {
	if(this.state.name == '' ){
		return false;	
	 // $('.error_name').html('<span class="errorspan">Please fill the field</span>') : $('.error_name').html('');
 
	}
	const Index = this.state.editindex;
 
	const newItem = {
		name: this.state.name,
		module_type_value: this.state.module_type_value,
		priorty: this.state.priorty,
		count_size: this.state.count_size,
		text_color: this.state.text_color,
		count_color: this.state.count_color,
		text_size: this.state.text_size,
		content: this.state.content,
		new_image: this.state.image,
		image_name:this.state.image_name,
		image_preview: this.state.image_preview,
		db_image_name:this.state.db_image_name,
		db_bg_image_name:this.state.db_bg_image_name,
		bg_image_name:this.state.bg_image_name,
		new_bg_image:this.state.bg_image,
		bg_image_preview: this.state.bg_image_preview,
		icon_image: this.state.icon_image,
		icon_preview: this.state.icon_preview,
		enable_list: this.state.enable_list,
		show_count: this.state.show_count,
		show_tooltip: this.state.show_tooltip,
		dashboard_block: this.state.dashboard_block,
		show_tooltip: this.state.show_tooltip,
		icon_width: this.state.icon_width,
		icon_color:this.state.icon_color,
		icon_color_filter:this.state.icon_color_filter,
		dashboard_img_type: this.state.dashboard_img_type,
		status:this.state.selectedvalue == 'inactive'? 'I':'A',
		// dashb_img_max_height: this.state.dashb_img_max_height,
		// dashb_img_max_width: this.state.dashb_img_max_width,
		// dashb_img_position: this.state.dashb_img_position,
		action: this.state.dashboarddata[Index] ?.id ? "edit":"add",
	};
 
	const updatedDashboardData = [...this.state.dashboarddata];
 
	if(Index !== ''){
		updatedDashboardData[Index] = {
			...updatedDashboardData[Index],
			...newItem
		};
	} else {
		updatedDashboardData.push(newItem);
	}
 
	const blockCounts = {
		block1: updatedDashboardData.filter(item => item.dashboard_block === 'block1').length,
		block2: updatedDashboardData.filter(item => item.dashboard_block === 'block2').length,
		block3: updatedDashboardData.filter(item => item.dashboard_block === 'block3').length,
		block4: updatedDashboardData.filter(item => item.dashboard_block === 'block4').length
	};
 
	this.setState({dashboarddata: updatedDashboardData, blockCounts: blockCounts, showlayout: true}, () => {
		this.setState({
			name: '',
			module_type_value: '',
			priorty: '',
			count_size: '',
			text_color: '',
			count_color: '',
			text_size: '',
			content: '',
			image: '',
			image_name: '',
			image_preview: '',
			icon_image: '',
			icon_name: '',
			icon_preview: '',
			editindex: '',
			new_image: '',
			bg_image_name:'',
			bg_image:'',
			bg_image_preview:'',
			db_image_name:'',
			db_bg_image_name:'',
			icon_width:'',
			icon_color:'',
			icon_color_filter:'',
			dashboard_block_sel: '',
			module_type: '',
			module_type_value:''
		});
		this.getformlayout();
		//scrollToTop();
		this.handleFormSubmit();
		$('#addbutton').html('Add');
	});
   }
  validateFormfield() {
		const {form_field_name,form_input_type_value,field_required,field_priorty,select_options} = this.state;
		let errors = 0;
	
		if (!form_field_name) {
			errors++;
			$('.errorfieldname').html('<span class="errorspan">Please fill the field</span>');
		}else if(form_field_name){
			$('.errorfieldname').html('');
		}


		if (!form_input_type_value) {
			errors++;
			$('.errortype').html('<span class="errorspan">Please select input type</span>');
		}else if(form_input_type_value){
			$('.errortype').html('');
		}

		if(!field_priorty){
		errors++;
			$('.errorpriority').html('<span class="errorspan">Please fill the field</span>');
		}else if(field_priorty){
			$('.errorpriority').html('');
		}

		if(form_input_type_value == 'select'){
			if(!select_options){
				errors++;
				$('.erroroptions').html('<span class="errorspan">Please fill the field</span>');
			}else if(select_options){
				$('.erroroptions').html('');
			}
		}

		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}

    }

    componentWillReceiveProps(Props){

    	
    
  }

    showConfirmDelete(Index){
		 const itemToDelete = this.state.dashboarddata[Index];
	     const columnnmame = itemToDelete?.column_name;
			//var qs = require('qs');
			// var postObject = {
			//   admin_id : localStorage.getItem("admin_id"),
			//   id  :id
			// };
		  //this.props.getDeleteCar(qs.stringify(postObject));
		  this.setState({deleteId : Index})
		  console.log("deleteId",Index);
		  $('.confirm-action-delete-message').html('Are you sure! you want to delete the '+columnnmame+'?');	
		  $('.confirm-action-delete').addClass('show');	
		}
	 deleteConfirm =(confirmstatus,Index)=>{
    if(confirmstatus == 'yes'){
			$('.confirm-action-delete').removeClass('show');
			console.log("deleteId",this.state.deleteId);
			this.deletesinglefield(Index);
    //   var qs = require('qs');       
    //   var postObject = { 
    //     column: 'id',         
    //     value: id,   
    //     activePage:this.state.activePage,  
    //     admin_id:localStorage.getItem("admin_id")
    //   };
    //   axios.post(apiUrl+"creditcard/delete",qs.stringify(postObject)).then(res => {
    //     if(res.data.status === 'success'){
    //       $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
    //       setTimeout(
    //       function() {
    //       $('.success_message').html('');
    //       }
    //       .bind(this),
    //       3000
    //       );

    //       this.listloadedData()
       
        //}
    //   });  
    }else{
      $('.confirm-action-delete').removeClass('show');	
    }
    }
    deletesinglefield(Index){
	  const itemToDelete = this.state.dashboarddata[Index];
	  const columnId = itemToDelete?.column_id;

	  const updatedDashboardData = [...this.state.dashboarddata];
	  updatedDashboardData.splice(Index, 1);

	  const blockCounts = {
		block1: updatedDashboardData.filter(item => item.dashboard_block === 'block1').length,
		block2: updatedDashboardData.filter(item => item.dashboard_block === 'block2').length,
		block3: updatedDashboardData.filter(item => item.dashboard_block === 'block3').length,
		block4: updatedDashboardData.filter(item => item.dashboard_block === 'block4').length
	  };

	  this.setState({dashboarddata: updatedDashboardData, blockCounts: blockCounts});

	  if(columnId) {
		this.setState(
			(prevState) => ({
				remove_ids: [...prevState.remove_ids, columnId],
			}),
			() => {
				this.handleFormSubmit();
			}
			);
	  }
  }
  editsinglefield = (index) => {
	$('.error_name').html('');
		$('.error_module_type_value').html('');
		$('.error_priorty').html('');
		$('.error_count_size').html('');
		$('.error_text_color').html('');
		$('.error_text_size').html('');
		const editdata =  this.state.dashboarddata[index];
		this.setState({
			    name:editdata.column_name,
				priorty:editdata.priority,
				text_size:editdata.text_size,
				text_color:editdata.text_color,
				count_color:editdata.count_color,
				count_size:editdata.count_size,
				//content: editdata.content,
				editindex: index,
				dashboard_img_type:editdata.dashboard_img_type,
				// dashb_img_max_height:editdata.dashb_img_max_height,
				// dashb_img_max_width:editdata.dashb_img_max_width,
				// dashb_img_position:editdata.dashb_img_position,
				dashboard_block: editdata.dashboard_block,
				show_tooltip: editdata.show_tooltip,
				show_count: editdata.show_count,
				icon_width: editdata.icon_width,
				icon_color: editdata.icon_color ? editdata.icon_color :'#ffffff',
				image_preview: editdata.image_preview || "",
				db_image_name: editdata.db_image_name || editdata.image || '',
				bg_image_preview: editdata.bg_image_preview || "",
				db_bg_image_name:editdata.db_bg_image_name || editdata.bg_image
			 });

		if(editdata?.status === 'A'){
			this.setState({selectedOption:{value: 'active', label: 'Active'},selectedvalue:'active'});
		}else{
			this.setState({selectedOption:{value: 'inactive', label: 'Inactive'},selectedvalue:'inactive'});
		}
		if(editdata?.icon_color){
			const hex = editdata.icon_color;			
			const { filter, loss } = computeFilterFromHex(hex);
			this.setState({ 
				icon_color_filter: filter,
				icon_color_loss: loss,
			 });
		}
		
		const selectedblock = lang.common.dashboard_blocks.find(
			(opt) => opt.value === editdata.dashboard_block
			);

		const selectedlink = this.state.filtered_page_options.find(
			(opt) => opt.value === editdata.select_option
		);

		
		this.setState({
			dashboard_block_sel: selectedblock ? [selectedblock] : [],
			module_type: selectedlink,
			module_type_value:editdata.select_option
		});
		$('#addbutton').html('Update');
  }
  getformlayout(){
      var form_field_value =this.state.dashboarddata;
      if (Object.keys(form_field_value).length > 0) {
      const formlayout = form_field_value.map(
      (datas, Index) => {
      let indexdata = Index+1;
      return (
            <div key={Index+'list'}>
            <li className="sortablecontainer-module-list border-0 ps-0 d-flex align-item-start w-100">
            {/* <i class="fa fa-chevron-right" aria-hidden="true"></i> */}
			<p className='text-break w-75'><b>{indexdata}. </b>
            {datas.column_name || datas.name}
			</p>
            <div className="sortablecontainer-module-edit-button w-25 d-flex justify-content-end gap-3">
			
			<a onClick={this.editsinglefield.bind(this,Index)}><svg height="22px" width="22px" xmlns="http://www.w3.org/2000/svg" viewBox="64 69.27 506.72 506.72"><path d="M535.6 85.7C513.7 63.8 478.3 63.8 456.4 85.7L432 110.1L529.9 208L554.3 183.6C576.2 161.7 576.2 126.3 554.3 104.4L535.6 85.7zM236.4 305.7C230.3 311.8 225.6 319.3 222.9 327.6L193.3 416.4C190.4 425 192.7 434.5 199.1 441C205.5 447.5 215 449.7 223.7 446.8L312.5 417.2C320.7 414.5 328.2 409.8 334.4 403.7L496 241.9L398.1 144L236.4 305.7zM160 128C107 128 64 171 64 224L64 480C64 533 107 576 160 576L416 576C469 576 512 533 512 480L512 384C512 366.3 497.7 352 480 352C462.3 352 448 366.3 448 384L448 480C448 497.7 433.7 512 416 512L160 512C142.3 512 128 497.7 128 480L128 224C128 206.3 142.3 192 160 192L256 192C273.7 192 288 177.7 288 160C288 142.3 273.7 128 256 128L160 128z"></path></svg></a>
			
			<a onClick={this.showConfirmDelete.bind(this,Index)}>
				<svg xmlns="http://www.w3.org/2000/svg" height="22px" width="22px" viewBox="96 48 448 528"><path d="M232.7 69.9L224 96L128 96C110.3 96 96 110.3 96 128C96 145.7 110.3 160 128 160L512 160C529.7 160 544 145.7 544 128C544 110.3 529.7 96 512 96L416 96L407.3 69.9C402.9 56.8 390.7 48 376.9 48L263.1 48C249.3 48 237.1 56.8 232.7 69.9zM512 208L128 208L149.1 531.1C150.7 556.4 171.7 576 197 576L443 576C468.3 576 489.3 556.4 490.9 531.1L512 208z"></path></svg>
			</a>

            {/* <button onClick={this.editsinglefield.bind(this,Index)} >Edit</button>
            <button onClick={this.deletesinglefield.bind(this,Index, this.state.field_ids[Index])}>Delete</button> */}
            </div>
            </li></div> );

      }
      );
      return formlayout;
      }
  }
 getdeleteall = () => {
  this.setState(prevState => ({
    showlayout: false,
    removeall_ids: prevState.dashboarddata
      .filter(item => item.column_id)
      .map(item => item.column_id)
  }));
};

  handlefieldTypeChange(selectname,event) {
	console.log("=== HANDLEFIELDTYPECHANGE ===");
	console.log("selectname:", selectname);
	console.log("event object:", event);
	console.log("event.value:", event.value);
	if(selectname=='link_to') {
		console.log("Link To selected, setting value:", event.value);
		this.setState({module_type:[event],module_type_value:event.value})
	}else if(selectname=='dashboard_block') {
		console.log("Dashboard Block selected, setting value:", event.value);
       this.setState({dashboard_block_sel:[event],dashboard_block:event.value}, () => {
	   	console.log("State updated - dashboard_block is now:", this.state.dashboard_block);
	   })
	} else if(selectname=='status') {
		console.log("status update");

		this.setState({selectedOption:[event],selectedvalue:event.value})
	}
}

  getDisabledBlockOptions = () => {
	const { blockCounts } = this.state;
	const blockOptions = lang.common.dashboard_blocks.map(block => {
		const blockCount = blockCounts[block.value] || 0;
		const isDisabled = blockCount >= block.columncount;
		return {
			...block,
			isDisabled: isDisabled
		};
	});
	blockOptions.push({ value: '', label: 'No block', columncount: 4 });
	return blockOptions;
   }

  render() {
  const {selectedOption,showlayout,login_type, image_name_single,db_bg_image_name,db_image_name} = this.state;
			let preview = '';
			let iconPreview = null;
		
			if (db_image_name !=='') {
				const imagepre = mediaUrl+'dashboard/'+this.state.db_image_name;
				preview = <img className="img_class" src={imagepre} alt="" width={100} height={100}/>;
			}

			if(this.state.image_preview!==''){
					preview = <img className="img_class" src={this.state.image_preview} alt="" width={100} height={100}/>;
			}

			if (this.state.icon_name_single) {
				const url = mediaUrl + "dashboard/" + this.state.icon_name_single;
				iconPreview = (
					<img className="img_class" src={url} width={100} height={100} />
				);
			}

			// From uploaded file
			if (this.state.icon_preview) {
				iconPreview = (
					<img className="img_class" src={this.state.icon_preview} width={100} height={100} />
				);
			}
			let bgpreview ='';
			
			if(db_bg_image_name !==null && db_bg_image_name !=='') {
				const bgimagepre = mediaUrl+'dashboard/'+db_bg_image_name;
				bgpreview = <img className="img_class" src={bgimagepre} alt="" width={100} height={100}/>;
			}
	
			if(this.state.bg_image_preview!==''){
					bgpreview = <img className="img_class" src={this.state.bg_image_preview} alt="" width={100} height={100}/>;
			}
			console.log(this.state.login_type,this.state.login_type.value,"this.state.login_type");
  return (
   <div className="wrapper"> 
   
    <Header />
    <MenuSidebar  currentpage="DashboardManagement" />		
    	<div className="content">	
    		<div className="content-wrapper">
			<div class="content-wrapper-before"></div>
			<div className="confirm-action confirm-action-delete">
          <p className="confirm-action-delete-message"></p>
          
          
          <a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.deleteId)} className="btn">Yes</a>
          <a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
          <span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
        </div>
			<div className="form-wrapper leaa-admin-head card">
    			<div className="success_message"></div>
				<a class="primary-btn" href="/dashboardmanagement">Back</a>
					<div className="title">
						<h4>Edit {this.state.login_type.value} dashboard</h4>
					</div>
    			<div className="content-body">
  			
        			
						<div className="builderpage-module-pagewrapper mb-5 pb-0 overflow-visible">
							<div className="sortablecontainer-module-wrapper builderpage-module-section box-wrapper ">
									<h2 className="typography-module-title" style={{marginBottom: '35px'}}>Manage Block Images</h2>
									<div  className="form-row mb-0">
									{lang.common.dashboard_blocks.map((block, index) => (
										
											<div key={`block-${block.value}`} className={index / 2 === 0 ? "form-right" : "form-left"}>
											<div className="form-group">
												
												
												{this.state.dashboard_blocks[index]?.preview ? (
													<div className='row'>
														<div className='col-12 col-xl-7'>
															<label className='pt-0'>Upload {block.label} background image:</label>
														</div>
														<div className="col-12 col-xl-5 d-flex gap-2 ">
														<div className="choose-file">
															{this.state.isHidden && <div className="bg_image_success"></div>}
															<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBlockBgImgHandler(index)} accept="image/*"/></span>
														</div>
														<img src={this.state.dashboard_blocks[index].preview} width={100} height={100} alt="preview" style={{maxHeight:"50px"}} />
														<span className='fw-bold cursor-pointer' onClick={() => this.removeBlockBgImagePreview(index)}>X</span>
														</div>
													</div>
												) : this.state.dashboard_blocks[index]?.db_bl_image_name ? (
													<div className='row'>
														<div className='col-12 col-xl-7'>
															<label className='pt-0'>Upload {block.label} background image:</label>
														</div>
														<div className="col-12 col-xl-5 d-flex gap-2 ">
															<div className="choose-file">
																{this.state.isHidden && <div className="bg_image_success"></div>}
																<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBlockBgImgHandler(index)} accept="image/*"/></span>
															</div>
															<img src={mediaUrl + 'dashboard/' + this.state.dashboard_blocks[index].db_bl_image_name} width={100} height={100} alt="preview" style={{maxHeight:"50px"}} />
															<span className='fw-bold cursor-pointer' onClick={() => this.removeBlockBgImagePreview(index)}>X</span>
														</div>
													</div>
												):(
													<div className='row'>
														<div className='col-12 col-xl-7'>
															<label className='pt-0'>Upload {block.label} background image:</label>
														</div>
													<div className="col-12 col-xl-5 d-flex gap-2 ">
														<div className="choose-file">
															{this.state.isHidden && <div className="bg_image_success"></div>}
															<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBlockBgImgHandler(index)} accept="image/*"/></span>
														</div>
													</div>
												</div>
												)}
												<div className="errorloaderimage"></div>
											</div>
										
											{/* <label>Color (Background) ({block.label})<span class="required" style={{ color: "red" }} > * </span> : </label>
											<div className='d-flex form-field-accessibility-row'>
												<div className='form-field-accessibility-input'>
													<input type="text" className="form-control" value={this.state.dashboard_blocks[index]?.color || ''} onChange={(e) => this.handleDashboardBlockChange(index, 'color', e.target.value)}
													/>
												</div>
												<div className='form-field-accessibility-colorbx'>
													<input type="color" className="form-control" value={this.state.dashboard_blocks[index]?.color || ''} onChange={(e) => this.handleDashboardBlockChange(index, 'color', e.target.value)}
													/>
												</div>
											</div> */}
											{/* <div className="errorprimaryColor"></div> */}
										</div>
									))}
									<div className="d-flex justify-content-center w-100">
                                       <button onClick={this.handleFormSubmit} >Update</button>
									</div>
										</div>
							</div> 
						</div>
				<div className="builderpage-module-pagewrapper pt-2 ">
                <section className="builderpage-module-section">
				{this.state.dashboarddata.length > 0 && <> {(this.state.showlayout == true)?<> <h2 className="typography-module-title pt-4 mt-3 mb-4 text-start">{this.state.login_type_value} Menus <div className="sortablecontainer-module-delete-btn"><button onClick={this.getdeleteall.bind(this, this.state.field_ids)}>Delete All</button></div></h2>
				
                       <div className="sortablecontainer-module-wrapper">
                         <ul>
                           {this.getformlayout()}
                         </ul>
                         
                      </div></>:''}</>}
                  </section>
				  <form className="BuilderPage-module-form builderpage-module-section" onSubmit={ (e) => { e.preventDefault(); this.handleFormSubmit(this); }}>

						<div className="form-group">
							<label className='pt-4'>User Type:</label>
							<input type="text" className="form-control" placeholder="Login Type" name="login_type" value={this.state.login_type.value} onChange={this.handleInputChange} autoComplete="off" readOnly/>
						</div>
						{/* <div className="form-group">					
						<label>User Type :</label>
						<Select 
						value={this.state.login_type.value}
						options={lang.common.login_type} 
						onChange={this.handleChange}
						isDisabled ={true}
						/>
						</div> */}
						{/* <div className="form-group radio-check">
						<label>Choose layout</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" checked/>
								<label className="form-check-label" for="show_count_yes">
								One Column
								</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_no" />
								<label className="form-check-label" for="show_count_no">
								Two Column
								</label>
						</div> */}
						
						<h2 className="typography-module-title">{this.state.editindex !=''? "Edit" : "Add"}  Menu</h2>
						<div className='row'>
							<div className='col-xl-6 col-6'>
								<div className="form-group">
									<label>Title/Tooltip:</label>
									<input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleInputChange} autoComplete="off" />
									<div className="errorname"></div>
								</div>
							</div>
							<div className='col-xl-6 col-6'>
								<div className="form-group radio-check">
									<label className='pb-2 d-block'>Show Tooltip</label>
									<input className="form-check-input ms-0" type="radio" name="show_tooltip"  value="yes" onChange={this.handleInputChange} checked={this.state.show_tooltip === 'yes'} />
										<label className="form-check-label" htmlFor="show_count_yes"> Yes </label>
									<input className="form-check-input" type="radio" name="show_tooltip"  value="no" onChange={this.handleInputChange} checked={this.state.show_tooltip === 'no'} />
									<label className="form-check-label" htmlFor="show_count_no"> No</label>
								</div>
							</div>
						</div>
						
						<div className='row'>
							<div className='col-xl-6 col-6'>
								<div className="form-group">
									<label>Link To: </label>
									<Select 
									value={this.state.module_type!=''?this.state.module_type:'Choose'}
									options={this.state.filtered_page_options} 
									onChange={this.handlefieldTypeChange.bind(this,'link_to')}
									isSearchable={false}
									/>
									<div className="errormodule"></div>
								</div>
							</div>
							<div className='col-xl-6 col-6'>
								<div className="form-group">
									<label>Block: </label>
									<Select
									value={this.state.dashboard_block_sel!=''?this.state.dashboard_block_sel:'Choose'}
									options={this.getDisabledBlockOptions()}
									onChange={this.handlefieldTypeChange.bind(this,"dashboard_block")}
									isSearchable={false}
									/>
									<div className="errormodule"></div>
								</div>
							</div>
						</div>
												
						{/* {(this.state.module_type_value == 'select' || this.state.module_type_value == 'checkbox' || this.state.module_type_value == 'radio')?<div className="form-group">
						<label>Options:</label>
						<input type="text" name="select_options" className="form-control" value={this.state.select_options} placeholder="Enter options separate by ," onChange={this.handleInputChange} autoComplete="off" />
						<div className="erroroptions"></div>
						</div>:''} */}
						
						{/* <div className="form-group">
							<label>Content : </label>
							<input type="text" name="content" className="form-control" value={this.state.content} placeholder="Content" onChange={this.handleInputChange} autoComplete="off" />
						</div> */}

						<div className="row">
							<div className="col-xl-6">
								<div className="form-group">
									<label>Icon:</label>
									<div className="choose-file">
										{this.state.isHidden && <div className="image_success"></div>}
										<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} accept="image/*"/></span>
									</div>
									{preview && preview !== '' && <div className='d-flex gap-2'>{preview} <span className='fw-bold cursor-pointer' onClick={this.removeImagePreview}>X</span></div>}
									<div className="errorloaderimage"></div>
								</div> 
							</div> 
							<div className="col-xl-6">
								<div className="form-group">
									<label>Icon width:</label>
									<input type="text" name="icon_width" className="form-control" value={this.state.icon_width}  onChange={this.handleInputChange} autoComplete="off" />
									<div className="erroriconwidth"></div>
								</div>
							</div> 
							
						</div>
						<div className="form-group">
							<label>Background color:</label>
								<div className='d-flex form-field-accessibility-row'>
									<div className='form-field-accessibility-input'>
										<input type="text" className="form-control" name="icon_color" value={this.state.icon_color || ''} onChange={this.handleInputChange}
										/>
									</div>
									<div className='form-field-accessibility-colorbx'>
                                        <input type="color" className="form-control" id="head" name="icon_color" value={this.state.icon_color} onChange={this.handleInputChange} />

										{/* <input type="color" className="form-control" name="icon_color" value={this.state.icon_color || ''}  onChange={this.handleInputChange} 
										/> */}
									</div>
								</div>
								<div className="errorprimaryColor"></div>

						</div> 
						<div className="row">
							<div className="col-xl-6">
								<div className="form-group">
									<label>Background image:</label>
									<div className="choose-file">
										{this.state.isHidden && <div className="bg_image_success"></div>}
										<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBgImgHandler} accept="image/*"/></span>
									</div>
									{bgpreview && bgpreview !== '' && <div className='d-flex gap-2'>{bgpreview} <span className='fw-bold cursor-pointer' onClick={this.removeBgImagePreview}>X</span></div>}
									<div className="errorloaderimage"></div>
								</div> 
							</div>
							<div className="col-xl-6">
								<div className="form-group radio-check">
									<label className='d-block pb-2'>Show Count</label>
									<input className="form-check-input ms-0" type="radio" name="show_count" id="show_count_yes" value="yes" onChange={this.handleInputChange} checked={this.state.show_count === 'yes'} />
										<label className="form-check-label" htmlFor="show_count_yes"> Yes </label>
									<input className="form-check-input" type="radio" name="show_count" id="show_count_no" value="no" onChange={this.handleInputChange} checked={this.state.show_count === 'no'} />
									<label className="form-check-label" htmlFor="show_count_no"> No</label>
								</div>
							</div>
						</div>
						

						{/* <div className="form-group">
							<input className='ms-0' onChange={this.handleInputChange} type="checkbox"  name="mini_dropdown_list" 
							checked={this.state.mini_dropdown_list}/>
							<label>Dashboard List:</label>
						</div> */}
						{/* <div className="form-group radio-check">
								<label>Show Count</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" onChange={this.handleInputChange} checked={(this.state.show_count_yes == true ? "checked" : "" )}/>
								<label className="form-check-label" for="show_count_yes">
								Yes
								</label>
								<input className="form-check-input" type="radio" name="show_count" onChange={this.handleInputChange}  id="show_count_no" checked={(this.state.show_count_no == true ? "checked" : "" )} />
								<label className="form-check-label" for="show_count_no">
								No
								</label>
						</div> */}
						<div className="row">
							<div className="col-xl-6">
								<div className="form-group">
									<label>Priority : </label>
									<input type="text" name="priorty" className="form-control" value={this.state.priorty}  onChange={this.handleInputChange} autoComplete="off" />
									<div className="errorpriority"></div>
								</div>
							</div>
							<div className="col-xl-6">
								<div className="form-group">
									<label>Text size:</label><br></br>
									<input type="input" id="head" name="text_size" className="form-control" value={this.state.text_size} onChange={this.handleInputChange} />
									<div className="error_text_size"></div>
								</div>
							</div>
						</div>
						
						
						<div className="form-group">
							<label>Count size:</label><br></br>
							<input type="text" id="head" name="count_size" className="form-control" value={this.state.count_size} onChange={this.handleInputChange} />
							<div className="error_count_size"></div>
						</div>
						<div className="row">
							<div className="col-xl-6">
								<div className="form-group">
									<label>Text color:</label><br></br>
									<input type="color" id="head" name="text_color" value={this.state.text_color} onChange={this.handleInputChange} />

									<div className="error_text_color"></div>
								</div>
							</div>
							<div className="col-xl-6">
								<div className="form-group">
									<label>Count color:</label><br></br>
									<input type="color" id="head" name="count_color" value={this.state.count_color} onChange={this.handleInputChange} />

									<div className="error_count_color"></div>
								</div>
							</div>
							 <div className="form-group">					
						        <label>Status:</label>
								<Select 
								
								value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
								options={lang.common.status_option} 
								onChange={this.handlefieldTypeChange.bind(this,"status")}

								/>
						</div> 
						</div>
						<div className='product-subscription-form-row pt-4 mt-4'>
						<div className="submit-button">
						<span className="btn btn_orange btn_minwid login_submit animate-btn2" id="addbutton" onClick={this.Addtolayout}>Add</span>
						</div>
						<div className="">	
						{/* <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
											<span className="load-data"></span> 
											}Submit
						</button> */}
						</div>
						</div>
						</form>
          </div>
  			</div>	
			</div>
  		</div>	
  	</div>
  </div>
  );
  }
  }

export default (withRouter(Edit));